<template>
  <div class="add-appointment-notes">
    <div class="input-wrapper notes-wrapper timing-wrapper wrapping-input">
      <span href="#" @click.stop.prevent="display = true">Notes</span>
      <!-- adding textarea -->
      <div
        rows="6"
        @input="setNotesLocal"
        class="textarea-appoitment edit-notes"
        contenteditable="true"
        ref="editableDiv"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import { notesMixin } from "../../../../mixins/notesMixin";

export default {
  methods: {
    ...mapMutations({
      setNotes: "setNotes"
    }),
    setNotesLocal() {
      this.setNotes(this.$refs.editableDiv.innerHTML);
    }
  },
  computed: {
    ...mapGetters({
      notes: "getNotes"
    })
  },
  mixins: [notesMixin]
};
</script>

<style scoped>
div.input-wrapper {
  margin-bottom: 100px !important;
}
#add-appointment-notes .input-wrapper.notes-wrapper.wrapping-input {
  max-width: 98%;
  margin: 0 auto;
}
.edit-notes {
  padding: 10px;
  overflow: auto;
  height: 100px;
  max-width: 96%;
}

</style>
